import { defaultAgent, apiResponse } from '../../helpers/web-agent';
import { Shape } from '../map/geo/DrawingTools';

export default class LoadTripWorkWindow {
    constructor(map, google) {
        this.map = map;
        this.google = google;
        this.getTrip = null;
        this.workWindows = {};

        this.defaultShapeProperties = {
            fillColor: "#ffc107",
            fillOpacity: 1,
            strokeColor: "#ffc107",
            strokeWeight: 2,
            strokeOpacity: 1,
            zIndex: 199
        };
    }

    getWorkWindow(params) {
        const trips = [];
        for (const trip of Array.isArray(params) ? params : [params]) {
            for (const workWindowId of trip.workWindows) {
                trips.push({ tripId: trip.tripId, workWindowId });
            }
        }

        const workWindowIds = trips.map(e => e.workWindowId);
        const tripIds = trips.map(e => e.tripId);
        const requestId = `loadTripWorkWindow_${tripIds.join('')}`;
        return defaultAgent.get(`/api/farm/workwindow`, { work_window_uuid: workWindowIds }, { requestId }).then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.data && Array.isArray(agentResult.data.data) && agentResult.data.data.length > 0)
                return this.drawWorkWindow(agentResult.data.data, trips).setBounds(tripIds);
            else if (agentResult.message)
                return console.log(agentResult.message);
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Load Trip WorkWindow: ', ex.message);
        });
    }

    drawWorkWindow(workWindows, trips) {
        const me = this;
        const newWorkWindow = {};
        const shapeObj = this.getShapeInstance();

        for (const egItem of workWindows) {
            for (const workWindow of egItem.work_windows) {
                if (!(workWindow.shape && workWindow.shape.coordinates.length > 0)) continue;

                const workWindowId = workWindow.work_window_uuid;
                const findTrips = trips.filter(e => e.workWindowId === workWindowId)
                if (findTrips.length === 0) continue;
                const { tripId } = findTrips[0];

                const wwProps = {
                    id: workWindowId,
                    type: workWindow.shape.type.toLowerCase(),
                    location: workWindow.shape.coordinates[0].map(e => ({ lat: e[1], lng: e[0] })),
                    properties: { ...this.defaultShapeProperties }
                };

                const shape = shapeObj.createShape(wwProps);
                if (!shape) continue;
                shape.type = wwProps.type;
                shape.setMap(this.map);

                shapeObj.addClickListener(shape, position => {
                    me.openShapeInfowindow(shape, position, tripId);
                });

                if (!newWorkWindow[workWindowId]) newWorkWindow[workWindowId] = {};
                newWorkWindow[workWindowId] = { tripId, workWindowId, shape, infowindow: null };
            }
        }

        this.workWindows = { ...this.workWindows, ...newWorkWindow };
        return this;
    }

    openShapeInfowindow(shape, position, tripId) {
        if (!this.getTrip) return;

        const workWindowId = shape.id;
        if (!this.workWindows[workWindowId]) return;

        let { infowindow } = this.workWindows[workWindowId];
        const tripData = this.getTrip({ tripId, workWindowId });
        if (!tripData) return;

        const me = this;
        /*  const contentString = `<div class='info-load-trip'>
             <table/>
                 <tr><td><span class='text-label'>Visit ID</span></td> <td>:</td> <td><span class='text-value'>${tripData.visitId}</span></td></tr>
             </table>
         </div>`; */
        const contentString = `<div class='info-load-trip'>
                <div className="visit-date">
                    ${tripData.visitDate}
                </div>
                <div class="visit-number">
                    ${tripData.visitId}
                </div>
                <div class="visit-label">
                    Visit
                </div>
            <div>`;

        if (infowindow) {
            infowindow.setPosition(position);
        } else {
            infowindow = new this.google.maps.InfoWindow({
                content: contentString,
                disableAutoPan: true,
                position
            });

            infowindow.addListener("closeclick", function () { me.clearSelection(shape) });
            this.workWindows[workWindowId].infowindow = infowindow;
        }

        infowindow.open(this.map);
        this.setSelection(shape);
        return this;
    }

    setSelection(shape) {
        if (!shape) return this;
        if (shape.type === this.google.maps.drawing.OverlayType.MARKER) return this;
        this.workWindows[shape.id].options = { strokeColor: shape.get('strokeColor'), strokeWeight: shape.get('strokeWeight') };
        shape.setOptions({ strokeColor: "#fff", strokeWeight: shape.get('strokeWeight') });
        return this;
    }

    clearSelection(shape) {
        if (!shape) return this;
        if (shape.type === this.google.maps.drawing.OverlayType.MARKER) return this;
        if (!this.workWindows[shape.id].options) return this;
        shape.setOptions({ ...this.workWindows[shape.id].options });
        return this;
    }

    setBounds(tripsIds) {
        if (typeof tripsIds === "string") tripsIds = [tripsIds];

        const shapeObj = this.getShapeInstance();
        let bounds = null;

        for (const workWindowId in this.workWindows) {
            const workWindow = this.workWindows[workWindowId];
            if (tripsIds && tripsIds.indexOf(workWindow.tripId) < 0) continue;
            if (!workWindow.shape) continue;

            const location = shapeObj.getLocation(workWindow.shape, true);
            for (const coordinate of location) {
                if (!bounds) bounds = new this.google.maps.LatLngBounds();
                bounds.extend(coordinate);
            }
        }

        if (bounds) this.map.fitBounds(bounds);
        return this;
    }

    clearWorkWindows() {
        for (const workWindowId in this.workWindows) {
            const workWindow = this.workWindows[workWindowId];
            if (workWindow.shape) workWindow.shape.setMap(null);
            if (workWindow.infowindow) workWindow.infowindow.setMap(null);
            delete this.workWindows[workWindowId];
        }
        return this;
    }

    removeWorkWindow(tripId) {
        for (const workWindowId in this.workWindows) {
            const workWindow = this.workWindows[workWindowId];
            if (workWindow.tripId !== tripId) continue;
            if (workWindow.shape) workWindow.shape.setMap(null);
            if (workWindow.infowindow) workWindow.infowindow.setMap(null);
            delete this.workWindows[workWindowId];
        }
    }

    getShapeInstance() {
        if (!this.shapeObj) this.shapeObj = new Shape(this.google);
        return this.shapeObj;
    }
}